// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a1fa44c0","787":"b72fe7ed"}[chunkId] + ".chunk.js";
};